var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#fffefa",
    opacity: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.474,51.573c.011.153.011.306.011.46A9.988,9.988,0,0,1,5.428,62.089,9.988,9.988,0,0,1,0,60.5a7.311,7.311,0,0,0,.854.044,7.079,7.079,0,0,0,4.388-1.51,3.541,3.541,0,0,1-3.3-2.451,4.457,4.457,0,0,0,.668.055,3.738,3.738,0,0,0,.93-.12A3.535,3.535,0,0,1,.7,53.05v-.044a3.56,3.56,0,0,0,1.6.449A3.54,3.54,0,0,1,1.2,48.728a10.047,10.047,0,0,0,7.288,3.7,3.99,3.99,0,0,1-.088-.81A3.538,3.538,0,0,1,14.521,49.2a6.959,6.959,0,0,0,2.243-.854,3.525,3.525,0,0,1-1.554,1.948,7.086,7.086,0,0,0,2.035-.547A7.6,7.6,0,0,1,15.474,51.573Z",
    transform: "translate(7.046 -38.629)",
    fill: "#816920"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon-twitter.fb166ced.svg";
export { ForwardRef as ReactComponent };